module.exports = __webpack_public_path__ + "img/r-cb6-r2-green.bccf6206.gif";